<app-table
  [config]="config"
  [customActionsTemplateRef]="customActionsTemplateRef"
  [customCellTemplateRef]="customCellTemplateRef" />

<ng-template
  #customCellTemplateRef
  let-column="column"
  let-model="model">
  <app-admin-subscription-list-custom-cell-template
    [column]="column"
    [model]="model" />
</ng-template>

<ng-template #customActionsTemplateRef>
  <app-admin-subscription-list-actions
    (afterActionExecuteEvent)="handleAfterActionExecuteEvent($event)" />
</ng-template>

<p-drawer
  [customCloseEvent]="customBillingAddressEditDialogCloseEvent"
  [visible]="billingAddressEditVisibility()"
  appDrawerSidebar
  position="right"
  size="xl">
  <ng-template #header>
    <app-drawer-title>
      Edycja adresu rozliczeniowego subskrypcji
    </app-drawer-title>
  </ng-template>

  <ng-template #content>
    <app-drawer-content>
      @if (selectedId(); as selectedId) {
        <app-admin-subscription-billing-address-edit
          (submitEvent)="handleBillingAddressSubmitEvent()"
          [id]="selectedId" />
      }
    </app-drawer-content>
  </ng-template>
</p-drawer>

<p-drawer
  [customCloseEvent]="customEditDialogCloseEvent"
  [visible]="subscriptionEditVisibility()"
  appDrawerSidebar
  position="right"
  size="lg">
  <ng-template #header>
    <app-drawer-title>Edycja subskrypcji</app-drawer-title>
  </ng-template>

  <ng-template #content>
    <app-drawer-content>
      @if (selectedId(); as selectedId) {
        <app-admin-subscription-edit
          [id]="selectedId"
          (submitEvent)="handleSubscriptionEditSubmitEvent()" />
      }
    </app-drawer-content>
  </ng-template>
</p-drawer>

<p-drawer
  [customCloseEvent]="customShippingAddressEditDialogCloseEvent"
  [visible]="shippingAddressEditVisibility()"
  appDrawerSidebar
  position="right"
  size="xl">
  <ng-template #header>
    <app-drawer-title>Edycja adresu dostawy subskrypcji</app-drawer-title>
  </ng-template>

  <ng-template #content>
    <app-drawer-content>
      @if (selectedId(); as selectedId) {
        <app-admin-subscription-shipping-address-edit
          (submitEvent)="handleShippingAddressSubmitEvent()"
          [id]="selectedId" />
      }
    </app-drawer-content>
  </ng-template>
</p-drawer>
